import { ILopSelectRequest } from "../../../models/request/dm-lop/ILopSelectRequest";
import { dm_lop_viewmodel } from "../../../models/response/dm-lop/dm_lop";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eLopChuNhiemDefine = {
    CHANGE_FILTER: {} as ILopSelectRequest,
    SELECT_START: {} as ILopSelectRequest,
    SELECT_SUCCESS: [] as dm_lop_viewmodel[],
    SELECT_ERROR: ""
}

export const eLopChuNhiemActionTypeIds = generateActionTypeIds(eLopChuNhiemDefine, "LOP_CHU_NHIEM")
export type ILopChuNhiemActionTypes = IGenericActionType<typeof eLopChuNhiemDefine, "LOP_CHU_NHIEM">
